module.exports = __webpack_public_path__ + "img/icon-trending.b4bb3e52.svg";